// import '@babel/polyfill';
import './tailwind.css';
import './sass/style.scss';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import SimpleShare from './plugins/simpleshare/index';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'jquery-validation';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';

import SplitType from 'split-type';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import Lenis from 'lenis';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Pjax from 'pjax';


const Message = (() => {
    let el = null;
    let timer = null;

    const createEl = () => {
        if (el) return el;
        el = document.createElement('div');
        el.className = 'message-toast';
        document.body.appendChild(el);
        return el;
    };

    return {
        show(txt, duration = 3000) {
            const toast = createEl();
            toast.textContent = txt;
            toast.classList.add('show');
            clearTimeout(timer);
            timer = setTimeout(() => {
                toast.classList.remove('show');
            }, duration);
        }
    };
})();


let submitting = false;

function formSubmit(form, formBtn){
	if( submitting ) return;
	submitting = true;
	const $form = $(form);
	const actionUrl = $form.attr('action');
	const formData = $form.serialize();
	$form.css('pointer-events', 'none');
	$.ajax({
		type: 'POST',
		dataType: 'json',
		url: actionUrl,
		data: formData,
		beforeSend(){
			Message.show('Submitting...');
		},
		success(data){
			if( data.success ){
				Message.show('Submission successful!');
				// $form.find('input[type="text"], textarea').val('');
				// $form.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
			} else {
				Message.show(data.msg);
			}
		},
		error(xhr, status, error){
			Message.show('Submission failed, please refresh and submit again');
			console.error('Error:', error);
		},
		complete(){
			$form.css('pointer-events', 'auto');
			submitting = false;
		}
	});
}

const calcListInnerHeight = () => {
    const heightControls = document.querySelectorAll<HTMLElement>('.height-control');
    const minWidth = 500;

    heightControls.forEach((el) => {
        const calcWidth = Number(el.dataset.width) || minWidth;
        if (window.innerWidth > calcWidth) {
            const heights = [...el.querySelectorAll<HTMLElement>('.get-item__height')].map(
                (item) => item.offsetHeight
            );
            const maxHeight = Math.max(...heights);
            el.querySelectorAll<HTMLElement>('.set-item__height').forEach(
                (item) => (item.style.height = `${maxHeight}px`)
            );
        } else {
            el.querySelectorAll<HTMLElement>('.set-item__height').forEach((item) => (item.style.height = ''));
        }
    });
};

const debounce = (func, delay) => {
    let timerId = null;
    return (...args) => {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(() => func(...args), delay);
    };
};

let lenis;
const initSmoothScrolling = () => {
    lenis = new Lenis({
        smoothWheel: true,
        orientation: 'vertical'
    });

    // 关键：Lenis 滚动 → 通知 ScrollTrigger
    lenis.on('scroll', ScrollTrigger.update);

    // 统一用 GSAP ticker 驱动
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    // 禁用补帧，避免 iOS 跳动
    gsap.ticker.lagSmoothing(0);
};

initSmoothScrolling();


(function headerTheme() {     if (!document.body.classList.contains('header-glass')) return;
    const sections = document.querySelectorAll<HTMLElement>('[data-nav-theme-to]');
    const headerEl = document.querySelector<HTMLElement>('.header');
    if (!sections.length || !headerEl) return;

    const points: { top: number; theme: string }[] = [];

    function calc() {
        points.length = 0;
        sections.forEach((s) => {
            points.push({
                top: s.getBoundingClientRect().top + window.scrollY,
                theme: s.getAttribute('data-nav-theme-to') || 'light'
            });
        });
        points.sort((a, b) => a.top - b.top);
    }

    function update() {
        const pos = window.scrollY + window.innerHeight * 0.3;
        let theme = points[0]?.theme || 'light';
        for (let i = 0; i < points.length && points[i].top <= pos; i++) {
            theme = points[i].theme;
        }
        headerEl!.dataset.navTheme = theme;
    }

    calc();
    update();

    const st = ScrollTrigger.create({
        start: 0, end: 'max',
        onUpdate: update,
        onRefresh: calc
    });

    window.addEventListener('resize', calc);
})();


(function headerDropdown() {    
    const items = document.querySelectorAll<HTMLElement>('[data-dropdown]');
    const panels = document.querySelectorAll<HTMLElement>('.header__dropdown-panel');
    const dropdown = document.querySelector<HTMLElement>('.header__dropdown');
    const overlay = document.querySelector<HTMLElement>('.header__nav-overlay');
    if (!items.length || !dropdown) return;

    let closeTimer: ReturnType<typeof setTimeout> | null = null;

    function showPanel(id: string) {
        // 如果 toggle 菜单或 desktop nav 开着，直接关掉
        const headerEl = document.querySelector<HTMLElement>('.header');
        const desktopNav = document.querySelector<HTMLElement>('.header__desktop-nav');
        if (headerEl?.classList.contains('header--menu-open')) {
            headerEl.classList.remove('header--menu-open');
            const mobileNav = document.querySelector<HTMLElement>('.header__mobile-nav');
            if (mobileNav) gsap.set(mobileNav, { opacity: 0, pointerEvents: 'none' });
            if (desktopNav) {
                gsap.killTweensOf(desktopNav);
                gsap.set(desktopNav, { opacity: 0, pointerEvents: 'none', clearProps: 'x,xPercent,y' });
            }
        }

        cancelClose();
        dropdown.classList.add('show');
        overlay?.classList.add('is-visible');
        items.forEach((item) => {
            item.classList.toggle('is-active', item.dataset.dropdown === id);
        });
        panels.forEach((p) => {
            p.classList.toggle('is-open', p.id === `dropdown-${id}`);
        });
    }

    function closeAll() {
        items.forEach((item) => item.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-open'));
        dropdown.classList.remove('show');
        overlay?.classList.remove('is-visible');
    }

    function cancelClose() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function deferredClose() {
        cancelClose();
        closeTimer = setTimeout(closeAll, 200);
    }

    items.forEach((item) => {
        const id = item.dataset.dropdown;
        if (!id) return;

        item.addEventListener('pointerenter', () => showPanel(id));
        item.addEventListener('pointerleave', () => deferredClose());
    });

    dropdown.addEventListener('pointerenter', cancelClose);

    // 监听每个 panel 的离开，而非整个 dropdown（dropdown height:100% 盖住全屏）
    panels.forEach((p) => {
        p.addEventListener('pointerenter', cancelClose);
        p.addEventListener('pointerleave', deferredClose);

        // 图片预览切换（每个 column 独立）
        const columns = p.querySelectorAll<HTMLElement>('.header__dropdown-column');
        columns.forEach((col) => {
            const links = col.querySelectorAll<HTMLElement>('.header__dropdown-link[data-img]');
            const imageEl = col.querySelector<HTMLImageElement>('.header__dropdown-img');
            if (!imageEl) return;

            links.forEach((link) => {
                const imgSrc = link.dataset.img;
                if (!imgSrc) return;

                link.addEventListener('pointerenter', () => {
                    // 同一 column 内只有一个 is-active
                    col.querySelectorAll('.header__dropdown-item.is-active').forEach(el => el.classList.remove('is-active'));

                    const listItem = link.closest('.header__dropdown-item');
                    listItem?.classList.add('is-active');

                    gsap.killTweensOf(imageEl);
                    const preload = new Image();
                    preload.onload = () => {
                        gsap.to(imageEl, { opacity: 0, duration: .15, onComplete: () => {
                            imageEl.src = imgSrc;
                            gsap.to(imageEl, { opacity: 1, duration: .15 });
                        }});
                    };
                    preload.src = imgSrc;
                });
            });
        });
    });
})();

(function header() {    const body = $('body'),
        header = $('.header');
    let winBeforeSTop = 0;

    // header__spacer 同步 header 高度
    const spacer = document.querySelector<HTMLElement>('.header__spacer');
    const headerEl2 = document.querySelector<HTMLElement>('.header');
    function syncSpacer() {
        const h = headerEl2?.offsetHeight || 0;
        if (spacer) spacer.style.height = h + 'px';
        const mobileNav = document.querySelector<HTMLElement>('.header__mobile-nav');
        if (mobileNav) mobileNav.style.top = h + 'px';
        document.querySelectorAll<HTMLElement>('.header__mobile-submenu-group').forEach(g => {
            g.style.top = h + 'px';
        });
    }
    syncSpacer();
    window.addEventListener('resize', debounce(syncSpacer, 150));

    // lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
    //     // console.log({ scroll, limit, velocity, direction, progress })
    //     // scroll > 60 ? $body.addClass('fixed-menu') : $body.removeClass('fixed-menu')
    //     // scroll < winBeforeSTop ? $body.removeClass('drop') : $body.addClass('drop')
    //     // winBeforeSTop = scroll;
    // });

    // 移动端菜单
    const toggle = document.querySelector<HTMLElement>('.header__toggle');
    const headerEl = document.querySelector<HTMLElement>('.header');
    const items = document.querySelectorAll<HTMLElement>('.header__mobile-nav-item');
    let menuOpen = false;
    let actionsOrigWidth = 0;

    const mobileNav = document.querySelector<HTMLElement>('.header__mobile-nav');
    const desktopNav = document.querySelector<HTMLElement>('.header__desktop-nav');
    const actions = document.querySelector<HTMLElement>('.header__actions');
    const logo = document.querySelector<HTMLElement>('.header__logo');
    const headerInner = document.querySelector<HTMLElement>('.header__inner');
    const isDesktop = () => window.innerWidth > 1024;
    const isMobile = () => window.innerWidth <= 1024;

    toggle?.addEventListener('click', () => {
        menuOpen = !headerEl?.classList.contains('header--menu-open');
        if (menuOpen) {
            headerEl?.classList.add('header--menu-open');
            // 清掉 submenu/close 遗留的内联样式和 display:none
            if (mobileNav) {
                mobileNav.style.display = '';
                gsap.set(mobileNav, { clearProps: 'opacity,pointerEvents' });
            }

            if (isDesktop()) {
                // PC 端：显示 desktop nav，居中对齐 toggle + 从上方弹入
                if (desktopNav && toggle) {
                    const toggleRect = toggle.getBoundingClientRect();
                    const centerX = toggleRect.left + toggleRect.width / 2;
                    gsap.killTweensOf(desktopNav);
                    gsap.set(desktopNav, {
                        x: centerX,
                        xPercent: -30,
                        pointerEvents: 'auto'
                    });
                    gsap.fromTo(desktopNav,
                        { opacity: 0, y: 30 },
                        { opacity: 1, y: 0, duration: .5, ease: 'power3.out' }
                    );
                }
                if (mobileNav) {
                    gsap.killTweensOf(mobileNav);
                    gsap.set(mobileNav, { opacity: 0, pointerEvents: 'none' });
                }
            } else {
                // 移动端：显示 mobile nav
                if (mobileNav) {
                    gsap.killTweensOf(mobileNav);
                    gsap.set(mobileNav, { opacity: 1, pointerEvents: 'auto', x: 0, xPercent: 0 });
                }
                if (desktopNav) {
                    gsap.killTweensOf(desktopNav);
                    gsap.set(desktopNav, { opacity: 0, pointerEvents: 'none' });
                }

                // actions 撑满，logo 淡出
                if (actions && logo && headerInner) {
                    actionsOrigWidth = actions.offsetWidth;
                    gsap.to(actions, { width: headerInner.offsetWidth, duration: .4, ease: 'power3.out' });
                    gsap.to(logo, { opacity: 0, duration: .3, ease: 'power2.out' });
                }
            }

            gsap.set(items, { clearProps: 'all' });
            gsap.fromTo(items,
                { opacity: 0, y: 20 },
                { opacity: 1, y: 0, duration: .5, ease: 'power3.out', stagger: .04 }
            );
        } else {
            // 关闭时如果二级导航开着也一起隐藏
            document.querySelectorAll<HTMLElement>('.header__mobile-submenu-group').forEach(g => {
                gsap.to(g, { opacity: 0, y: 100, pointerEvents: 'none', duration: .2, ease: 'power2.in', onComplete: () => {
                    g.style.display = 'none';
                }});
            });

            if (isMobile() && actions && logo && actionsOrigWidth) {
                gsap.to(actions, { width: actionsOrigWidth, duration: .4, ease: 'power3.out' });
                gsap.to(logo, { opacity: 1, duration: .3, ease: 'power2.out' });
            }

            // 关闭：所有元素同时动画，不排队 — expo.out 首帧即全速，无停顿
            if (desktopNav) gsap.killTweensOf(desktopNav);

            const closeTl = gsap.timeline({
                onComplete: () => {
                    headerEl?.classList.remove('header--menu-open');
                }
            });

            // items 先动画
            closeTl.to(items, { opacity: 0, y: 15, duration: .18, ease: 'expo.out',
                onComplete: () => {
                    // items 动画结束后立刻隐藏 mobile nav，不延迟
                    if (mobileNav) gsap.set(mobileNav, { opacity: 0, pointerEvents: 'none' });
                }
            }, 0);
            if (desktopNav) {
                closeTl.to(desktopNav, { opacity: 0, y: 20, duration: .5, ease: 'expo.out',
                    onComplete: () => {
                        if (desktopNav) gsap.set(desktopNav, { pointerEvents: 'none', clearProps: 'x,xPercent,y,opacity' });
                    }
                }, 0);
            }
        }
    });

    // 移动端二级导航
    const submenuLinks = document.querySelectorAll<HTMLElement>('.header__mobile-nav-link[data-submenu]');
    const submenuGroups = document.querySelectorAll<HTMLElement>('.header__mobile-submenu-group');
    const submenuToggles = document.querySelectorAll<HTMLElement>('.header__mobile-submenu-toggle, .header__mobile-submenu-back');

    function showSubmenu(key: string) {
        if (mobileNav) {
            gsap.to(mobileNav, { opacity: 0, duration: .25, onComplete: () => {
                mobileNav.style.display = 'none';
            }});
        }
        submenuGroups.forEach(g => {
            const isTarget = g.dataset.submenuGroup === key;
            gsap.set(g, { display: isTarget ? 'block' : 'none' });
            if (isTarget) {
                gsap.fromTo(g,
                    { opacity: 0, y: 100 },
                    { opacity: 1, y: 0, pointerEvents: 'auto', duration: .3, ease: 'power2.out' }
                );
            }
        });
    }

    function hideSubmenu() {
        submenuGroups.forEach(g => {
            gsap.to(g, { opacity: 0, y: 100, pointerEvents: 'none', duration: .2, ease: 'power2.in', onComplete: () => {
                g.style.display = 'none';
            }});
        });
        if (mobileNav) {
            mobileNav.style.display = '';
            gsap.fromTo(mobileNav, { opacity: 0 }, { opacity: 1, duration: .25, ease: 'power2.out' });
        }
    }

    submenuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            showSubmenu(link.dataset.submenu!);
        });
    });

    submenuToggles.forEach(btn => {
        btn.addEventListener('click', hideSubmenu);
    });
})();


// (function buttonText() {
//     const btns = document.querySelectorAll<HTMLElement>('[data-button-text]');
//     if (!matchMedia('(hover: hover)').matches) return;

//     btns.forEach((btn) => {
//         const primary = btn.querySelector<HTMLElement>('[data-button-text-primary]');
//         if (!primary) return;

//         const text = primary.textContent || '';
//         const words = text.split(/(\s+)/);
//         const chars: HTMLElement[] = [];
//         const charsSec: HTMLElement[] = [];

//         function makeWordEl(word: string) {
//             const s = document.createElement('span');
//             s.className = 'split-char';
//             s.textContent = /^\s+$/.test(word) ? ' ' : word;
//             return s;
//         }

//         // 主层
//         primary.innerHTML = '';
//         words.forEach((w) => {
//             const el = makeWordEl(w);
//             primary.appendChild(el);
//             chars.push(el);
//         });

//         // 副层
//         const secondary = document.createElement('span');
//         secondary.className = 'arrow-link__text-secondary';
//         secondary.setAttribute('aria-hidden', 'true');
//         words.forEach((w) => {
//             const el = makeWordEl(w);
//             secondary.appendChild(el);
//             charsSec.push(el);
//         });
//         primary.appendChild(secondary);

//         // 初始态：副层藏在下方，全由 GSAP 管，不靠 CSS
//         gsap.set(charsSec, { yPercent: 100 });

//         const icon = btn.querySelector<HTMLElement>('[data-button-text-icon]');

//         // hover
//         btn.addEventListener('pointerenter', () => {
//             gsap.to(chars, {
//                 yPercent: -100,
//                 duration: .2,
//                 ease: 'power3.out',
//                 stagger: { amount: .15, from: 'start' }
//             });
//             gsap.to(charsSec, {
//                 yPercent: 0,
//                 duration: .2,
//                 ease: 'power3.out',
//                 stagger: { amount: .15, from: 'start' }
//             });
//             icon && gsap.to(icon, { x: 5, duration: .6, ease: 'power3.out' });
//         });

//         btn.addEventListener('pointerleave', () => {
//             gsap.to(chars, {
//                 yPercent: 0,
//                 duration: .2,
//                 ease: 'power3.out',
//                 stagger: { amount: .15, from: 'start' }
//             });
//             gsap.to(charsSec, {
//                 yPercent: 100,
//                 duration: .2,
//                 ease: 'power3.out',
//                 stagger: { amount: .15, from: 'start' }
//             });
//             icon && gsap.to(icon, { x: 0, duration: .3, ease: 'power3.out' });
//         });
//     });
// })();

(function cursor() {    // 触摸设备不启用自定义光标
    if (!matchMedia('(hover: hover)').matches) return;

    const cursorEl = document.querySelector<HTMLElement>('.cursor');
    if (!cursorEl) return;

    gsap.set(cursorEl, { xPercent: -50, yPercent: -50 });

    const xTo = gsap.quickTo(cursorEl, 'x', { duration: .3, ease: 'power3' });
    const yTo = gsap.quickTo(cursorEl, 'y', { duration: .3, ease: 'power3' });

    function onMove(e: MouseEvent) {
        xTo(e.clientX);
        yTo(e.clientY);
    }

    const zones = document.querySelectorAll<HTMLElement>('[data-cursor-zone]');

    function enter(e: MouseEvent) {
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        const cx = e ? e.clientX : rect.left + rect.width / 2;
        const cy = e ? e.clientY : rect.top + rect.height / 2;
        // 瞬间定位，避免从屏幕角落飞过来
        gsap.set(cursorEl, { x: cx, y: cy });
        cursorEl.classList.add('cursor--active');
        document.body.classList.add('cursor-hidden');
        window.addEventListener('pointermove', onMove, { passive: true });
    }

    function leave() {
        cursorEl.classList.remove('cursor--active');
        document.body.classList.remove('cursor-hidden');
        window.removeEventListener('pointermove', onMove);
    }

    zones.forEach((zone) => {
        zone.addEventListener('pointerenter', enter as EventListener);
        zone.addEventListener('pointerleave', leave);
        if (zone.matches(':hover')) enter(null as any);

        // 数据标签内隐藏光标，移出该标签但还在 zone 内则恢复
        const hideTriggers = zone.querySelectorAll<HTMLElement>('[data-cursor-hide]');
        hideTriggers.forEach((el) => {
            el.addEventListener('pointerenter', (e) => {
                e.stopPropagation();
                cursorEl.classList.remove('cursor--active');
                document.body.classList.remove('cursor-hidden');
            });
            el.addEventListener('pointerleave', (e) => {
                e.stopPropagation();
                cursorEl.classList.add('cursor--active');
                document.body.classList.add('cursor-hidden');
            });
        });
    });
})();


// (function splitHeading() {
//     const headings = document.querySelectorAll<HTMLElement>('[data-split-heading]');
//     if (!headings.length) return;
//     const charsMap = new Map<HTMLElement, HTMLElement[]>();
//     function splitNode(el: HTMLElement) { ... }
//     headings.forEach((el) => {
//         const chars = splitNode(el);
//         gsap.set(chars, { autoAlpha: 0, scaleY: 0, rotate: 0.001 });
//         el.style.visibility = 'visible';
//         charsMap.set(el, chars);
//     });
//     ScrollTrigger.batch(headings, {
//         start: 'top 85%', once: true,
//         onEnter: (batch) => {
//             batch.forEach((el) => {
//                 const chars = charsMap.get(el as HTMLElement);
//                 if (chars) gsap.to(chars, { autoAlpha: 1, scaleY: 1, rotate: 0, duration: 1, ease: 'power3.out', stagger: { amount: 0.5, from: 'center' } });
//             });
//         }
//     });
// })();


(function animateHeading() {
    const targets = document.querySelectorAll<HTMLElement>('.title-animated');
    if (!targets.length) return;

    function run() {
        targets.forEach((target) => {
            const ps = target.querySelectorAll('p');
            const elements = ps.length ? Array.from(ps) : [target];

            elements.forEach((ele) => {
                try {
                    const split = new SplitType(ele as HTMLElement, { types: 'lines,words', keepBr: true } as any);
                    const lines = Array.from(split.lines || []);

                    const fragment = document.createDocumentFragment();
                    lines.forEach((line) => {
                        const wrapper = document.createElement('div');
                        wrapper.className = 'line-wrapper';
                        wrapper.appendChild(line.cloneNode(true));
                        fragment.appendChild(wrapper);
                    });

                    // fragment.children 是 live 集合，逐次 replaceWith 会自然推进
                    lines.forEach((line) => {
                        line.replaceWith(fragment.children[0]);
                    });
                } catch (e) {
                    console.warn('animateHeading: SplitType failed', e);
                }
            });
        });

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const words = entry.target.querySelectorAll<HTMLElement>('.word');
                words.forEach((word, i) => {
                    setTimeout(() => word.classList.add('in-viewport'), i * 40);
                });
                obs.unobserve(entry.target);
            });
        }, { threshold: 0.5 });

        targets.forEach((target) => {
            const ps = target.querySelectorAll('p');
            const elements = ps.length ? Array.from(ps) : [target as HTMLElement];
            elements.forEach((ele) => observer.observe(ele as HTMLElement));
            requestAnimationFrame(() => target.classList.add('ready'));
        });
    }

    // 等字体加载完毕再拆分，避免用系统字体计算换行导致后期错位
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
    } else {
        run();
    }
})();




(function pageIndex() {    
    const heroTabs = document.querySelectorAll<HTMLElement>('.index__hero-tab');
    const heroSwiperEl = document.querySelector<HTMLElement>('.index__hero-slider');
    let heroSwiper: Swiper | null = null;

    if (heroSwiperEl) {
        heroSwiper = new Swiper(heroSwiperEl, {
            modules: [EffectFade, Autoplay],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            loop: true,
            speed: 1000,
            on: {
                slideChange: function() {
                    heroTabs.forEach((t, i) => {
                        t.classList.toggle('index__hero-tab--active', i === this.realIndex);
                    });
                }
            }
        });
    }

    // 点击 tab 切换 slide
    heroTabs.forEach((tab, i) => {
        tab.addEventListener('mouseenter', (e) => {
            e.preventDefault();
            heroTabs.forEach(t => t.classList.remove('index__hero-tab--active'));
            tab.classList.add('index__hero-tab--active');
            heroSwiper?.slideToLoop(i);
        });
    });

    // hero tab hover 时显示 tooltip（仅桌面端），8 秒后自动隐藏
    if (matchMedia('(hover: hover)').matches) {
        heroTabs.forEach((tab) => {
            const link = tab.querySelector<HTMLElement>('.index__hero-tab-link');
            const tooltip = tab.querySelector<HTMLElement>('.index__hero-tab-tooltip');
            if (!link || !tooltip) return;

            let hideTimer: ReturnType<typeof setTimeout> | null = null;

            const show = () => {
                tooltip.classList.add('is-visible');
                if (hideTimer) clearTimeout(hideTimer);
                hideTimer = setTimeout(() => tooltip.classList.remove('is-visible'), 6000);
            };
            const hide = () => {
                tooltip.classList.remove('is-visible');
                if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
            };

            link.addEventListener('pointerenter', show);
            link.addEventListener('pointerleave', hide);
        });
    }

    const featuredSwiperEl = document.querySelector<HTMLElement>('.index__featured-swiper');
    if (featuredSwiperEl) {
        new Swiper(featuredSwiperEl, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            }
        });
    }

    // $('.index__projects-card').on('click', function(){
    //     if( $(window).width() < 1025 ){
    //         // let imgSrc = $(this).find('.index__projects-card-image img').attr('src');
    //         $('.index__projects-modal').fadeIn(200);
    //     }
    // })

    // $('.index__projects-modal-close').on('click', function(){
    //         $('.index__projects-modal').fadeOut(200);
    // })

    // Projects tab toggle
    const projectsTabs = document.querySelectorAll<HTMLElement>('.index__projects-tab');
    const projectsPanels = document.querySelectorAll<HTMLElement>('.index__projects-panel');
    projectsTabs.forEach((tab, i) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            projectsTabs.forEach((t) => t.classList.remove('index__projects-tab--active'));
            projectsPanels.forEach((p) => p.classList.remove('index__projects-panel--active'));
            tab.classList.add('index__projects-tab--active');
            projectsPanels[i]?.classList.add('index__projects-panel--active');
        });
    });


    function statsNumber() {
        const numbers = document.querySelectorAll<HTMLElement>('.index__stats-number');
        if (!numbers.length) return;

        const charsMap = new Map<HTMLElement, HTMLElement[]>();

        numbers.forEach((el) => {
            const text = el.textContent || '';
            const chars: HTMLElement[] = [];
            el.innerHTML = '';

            text.split('').forEach((char) => {
                const span = document.createElement('span');
                span.className = 'split-char';
                span.style.display = 'inline-block';
                span.textContent = char;
                el.appendChild(span);
                chars.push(span);
            });

            gsap.set(chars, { autoAlpha: 0, yPercent: 100 });
            el.style.opacity = '1';
            charsMap.set(el, chars);
        });

        // rAF 轮询检测（绕过 Lenis/IntersectionObserver，每帧都查）
        function checkAndAnimate() {
            let allDone = true;
            numbers.forEach((el) => {
                if (el.dataset.statsDone) return;
                allDone = false;
                const r = el.getBoundingClientRect();
                if (r.top < window.innerHeight + 200 && r.bottom > -200) {
                    el.dataset.statsDone = '1';
                    const chars = charsMap.get(el);
                    if (chars) {
                        gsap.to(chars, {
                            autoAlpha: 1,
                            yPercent: 0,
                            duration: .4,
                            ease: 'power2.out',
                            stagger: .03
                        });
                    }
                }
            });
            if (allDone) return; // 全完成了就停
            requestAnimationFrame(checkAndAnimate);
        }
        // 等两帧布局稳定后再开始检测
        requestAnimationFrame(() => requestAnimationFrame(checkAndAnimate));
    };
    statsNumber();
})();

(function pageContact(){
     // Select 下拉
    document.querySelectorAll<HTMLElement>('.select').forEach((select) => {
        const trigger = select.querySelector<HTMLElement>('.select__trigger');
        const input = select.querySelector<HTMLInputElement>('.select__input');
        const links = select.querySelectorAll<HTMLElement>('.select__link');

        trigger?.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = select.classList.contains('select--open');

            // 关闭所有下拉
            document.querySelectorAll<HTMLElement>('.select--open').forEach((s) => {
                s.classList.remove('select--open');
            });

            // 如果本来关着的，打开当前
            if (!isOpen) {
                select.classList.add('select--open');
            }
        });

        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                if (input) {
                    input.value = link.textContent?.trim() || '';
                }
                select.classList.remove('select--open');
            });
        });
    });

    // 点击外部关闭所有下拉
    document.addEventListener('click', () => {
        document.querySelectorAll<HTMLElement>('.select--open').forEach((s) => {
            s.classList.remove('select--open');
        });
    });
})();




(function pageIndexFaq() {
    document.querySelectorAll<HTMLElement>('.index__faqs-question').forEach((q) => {
        q.addEventListener('click', () => {
            const li = q.closest('.index__faqs-item') as HTMLElement;
            const answer = li?.querySelector<HTMLElement>('.index__faqs-answer');
            // 关闭其他项
            const siblings = li?.parentElement?.querySelectorAll<HTMLElement>('.index__faqs-item');
            siblings?.forEach((sib) => {
                if (sib !== li) {
                    sib.classList.remove('is-active');
                    const sibAnswer = sib.querySelector<HTMLElement>('.index__faqs-answer');
                    if (sibAnswer) $(sibAnswer).slideUp(300);
                }
            });

            // 切换当前项
            li?.classList.toggle('is-active');
            if (answer) {
                $(answer).slideToggle(300);
            }
        });
    });
})();

(function pageFaq(){
    const panel = document.querySelector<HTMLElement>('.faq__tabs-panels');
    const headerH = document.querySelector<HTMLElement>('.header')?.offsetHeight || 0;

    document.querySelectorAll<HTMLElement>('.faq__tabs').forEach((tabsEl) => {
        const tabs = Array.from(tabsEl.querySelectorAll<HTMLElement>('.faq__tabs-list .tabs__tab'));
        const panels = tabsEl.querySelectorAll<HTMLElement>('.faq__tabs-panels .tabs__panel');
        // 预存索引，避免每次点击都从 DOM 重新算
        tabs.forEach((tab, i) => (tab as any)._idx = i);

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                const idx = (tab as any)._idx;

                // 只清除上一个 active，而不是全部遍历
                const prev = tabsEl.querySelector<HTMLElement>('.tabs__tab--active');
                if (prev && prev !== tab) prev.classList.remove('tabs__tab--active');
                const prevPanel = tabsEl.querySelector<HTMLElement>('.tabs__panel--active');
                if (prevPanel) prevPanel.classList.remove('tabs__panel--active');

                tab.classList.add('tabs__tab--active');
                panels[idx]?.classList.add('tabs__panel--active');

                // 只在 tabs nav 未 sticky 时才滚动，已吸顶说明面板已经在视野内了
                const tabsNav = tabsEl.querySelector<HTMLElement>('.faq__tabs-nav');
                const isSticky = tabsNav && tabsNav.getBoundingClientRect().top <= headerH + 2;
                if (isSticky) {
                    requestAnimationFrame(() => {
                        lenis.scrollTo(panels[idx].getBoundingClientRect().top + window.scrollY - headerH);
                    });
                }
            });
        });
    });
})();



(function pageCompany() {
    const timelineList = document.querySelector<HTMLElement>('.timeline__list');
    const timeline = document.querySelector<HTMLElement>('.timeline');

    if (timelineList && timeline) {
        timelineList.addEventListener('scroll', () => {
            
            if (timelineList.scrollTop > 10) {
                timeline.classList.add('timeline--scrolled');
            } else {
                timeline.classList.remove('timeline--scrolled');
            }
        });
    }
})();



(function pageSolutions() {
    const casesSwiperEl = document.querySelector<HTMLElement>('.solutions__cases-swiper');
    if (casesSwiperEl) {
        new Swiper(casesSwiperEl, {
            modules: [Navigation],
            slidesPerView: 'auto',
            // spaceBetween: window.innerWidth <= 1024
            //     ? Math.round(window.innerWidth * 20 / 750)
            //     : Math.round(parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--fluid-size'))),
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl: '.solutions__cases-next',
                prevEl: '.solutions__cases-prev'
            }
        });
    }
})();

(function pageDelivery(){
    
    // Testimonials Swiper
    const testimonialsSwiperEl = document.querySelector<HTMLElement>('.testimonials__swiper');
    if (testimonialsSwiperEl) {
        new Swiper(testimonialsSwiperEl, {
            modules: [Navigation, Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.testimonials__next',
                prevEl: '.testimonials__prev'
            },
            on: {
                init: function() {
                    const swiperEl = (this as any).el;
                    function equalizeHeights() {
                        // slides
                        const slides = swiperEl.querySelectorAll<HTMLElement>('.swiper-slide');
                        let maxH = 0;
                        slides.forEach((s: HTMLElement) => { s.style.height = 'auto'; });
                        slides.forEach((s: HTMLElement) => { maxH = Math.max(maxH, s.offsetHeight); });
                        slides.forEach((s: HTMLElement) => { s.style.height = maxH + 'px'; });
                        // quotes
                        const quotes = swiperEl.querySelectorAll<HTMLElement>('.testimonials__quote');
                        let maxQH = 0;
                        quotes.forEach((q: HTMLElement) => { q.style.height = 'auto'; });
                        quotes.forEach((q: HTMLElement) => { maxQH = Math.max(maxQH, q.offsetHeight); });
                        quotes.forEach((q: HTMLElement) => { q.style.height = maxQH + 'px'; });
                    }
                    equalizeHeights();
                    window.addEventListener('resize', debounce(equalizeHeights, 150));
                }
            }
        });
    }

    // Hub Swiper
    const hubSwiperEl = document.querySelector<HTMLElement>('.showcase__swiper');
    if (hubSwiperEl) {
        new Swiper(hubSwiperEl, {
            modules: [Navigation, Autoplay],
            slidesPerView: 'auto',
            watchOverflow: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            // navigation: {
            //     nextEl: '.delivery__hub-next',
            //     prevEl: '.delivery__hub-prev'
            // },
            // breakpoints: {
            //     0: {
            //         spaceBetween: 10
            //     },
            //     768: {
            //         spaceBetween: 20
            //     }
            // }
        });
    }
})();



(function init() {    const gotop = document.getElementsByClassName('js-gotop')[0] as HTMLElement | undefined;
    gotop?.addEventListener('click', () => {
        lenis.scrollTo(0);
    });

     AOS.init({
        once: true,
        mirror: false,
        duration: 700,
        anchorPlacement: 'top-center',
    });

    window.addEventListener('load', () => {
      AOS.refresh();
    });

     let myLazyLoad = new LazyLoad({
    	threshold: 800
    });


    let _pjax = new Pjax({
        elements: 'a.filter-Pjax',
        selectors: ['.filter__content'],
        cacheBust: false,
        scrollTo: false
    });
    function initLazyLoad() {
        if (myLazyLoad) myLazyLoad.update();
        else myLazyLoad = new LazyLoad({ threshold: 800 });
    }
    initLazyLoad();
    document.addEventListener('pjax:complete', initLazyLoad);

    function playVideo(){
        // 关闭并移除视频弹层；immediate 为 true 时跳过淡出直接移除
        function closeVideo(immediate){
            const $layer = $('.video-fixed');
            if (!$layer.length) return;
            $layer.find('video').trigger('pause');
            if (immediate) {
                $layer.remove();
            } else {
                $layer.fadeOut(200, function(){
                    $(this).remove();
                });
            }
            if (lenis) lenis.start();
        }

        // 打开弹层（事件委托：pjax 或后台动态插入的按钮也能生效）
        $(document).on('click', '.video-btn__play', function(){
            const videoSrc = String($(this).data('video') || '');
            if (!videoSrc) return;

            closeVideo(true); // 已有弹层时先移除，避免叠加

            const videoHtml = `
                <div class="video-fixed">
                    <button type="button" class="video-fixed__close" aria-label="Close video">
                        <svg t="1790061913805" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14927" width="200" height="200"><path d="M504.88296228 454.89873385L813.1779536 146.62730887a23.56635005 23.56635005 0 0 1 33.32281897 0l16.66140948 16.66140948a23.56635005 23.56635005 0 0 1 0 33.32281898L554.89075709 504.88296228 863.13861569 813.1779536a23.56635005 23.56635005 0 0 1 0 33.32281897l-16.66140948 16.66140948a23.56635005 23.56635005 0 0 1-33.32281897 0L504.88296228 554.89075709 196.61153733 863.13861569a23.56635005 23.56635005 0 0 1-33.32281898 0l-16.66140948-16.66140948a23.56635005 23.56635005 0 0 1 0-33.32281897l308.27142498-308.29499131-308.27142498-308.27142496a23.56635005 23.56635005 0 0 1 0-33.32281896l16.66140948-16.66140948a23.56635005 23.56635005 0 0 1 33.32281898 0l308.27142495 308.27142497z" p-id="14928"></path></svg>
                    </button>
                    <div class="video-fixed__inner">
                        <video controls autoplay muted playsinline webkit-playsinline></video>
                    </div>
                </div>
            `;
            const $layer = $(videoHtml).appendTo('body').hide().fadeIn(200);
            // 设置地址后主动触发播放（比单靠 autoplay 属性在移动端更可靠），
            // 被拒绝时（如 iOS 低电量模式）用户可通过 controls 手动播放
            const video = $layer.find('video').get(0);
            if (video) {
                video.src = videoSrc;
                const played = video.play();
                if (played && played.catch) played.catch(() => {});
            }

            if (lenis) lenis.stop();
        });

        // 关闭按钮（弹层是动态插入的，必须委托绑定）
        $(document).on('click', '.video-fixed__close', function(){
            closeVideo(false);
        });

        // 点击遮罩空白处关闭（点视频本身不关闭）
        $(document).on('click', '.video-fixed', function(e){
            if (e.target === this) closeVideo(false);
        });

        // Esc 键关闭
        $(document).on('keyup', function(e){
            if (e.key === 'Escape') closeVideo(false);
        });
    }
    playVideo();

    // console.log('desc');
    // $('#clndr').clndr();
    // addLayer();

    // if (isMobile.isMobile) {
    // 	console.log('Mobile');
    // } else {
    // 	console.log('Tablet');
    // }

    // cookieConsent();

    // Lazyload data-src data-bg data-poster
   

    Fancybox.bind("[data-fancybox]");
   


    // Social Share
    // const share = new SimpleShare({
    // 	url: '',
    // 	title: '',
    // 	content: '',
    // 	pic: ''
    // });
    // $('[data-share]').on('click', function () {
    // 	const type = $(this).attr('data-share');
    // 	share.goShare(type);
    // });
})();

(function pageWorkDetail() {
    const grid = document.querySelector<HTMLElement>('.work-detail__gallery-grid');
    const toggle = document.querySelector<HTMLElement>('.work-detail__gallery-toggle');
    if (!grid || !toggle) return;

    const items = grid.querySelectorAll<HTMLElement>('.work-detail__gallery-item');
    const VISIBLE = 8;
    if (items.length <= VISIBLE) return;

    // Show toggle, hide extra items
    toggle.classList.add('is-visible');

    const hideExtras = () => {
        for (let i = VISIBLE; i < items.length; i++) {
            items[i].classList.add('is-gallery-hidden');
        }
    };
    hideExtras();

    const section = toggle.closest<HTMLElement>('.work-detail__gallery');

    const expand = () => {
        for (let i = VISIBLE; i < items.length; i++) {
            items[i].classList.remove('is-gallery-hidden');
        }
        toggle.classList.add('is-expanded');
    };

    const collapse = () => {
        hideExtras();
        toggle.classList.remove('is-expanded');

        // 收拢时滚动回 gallery 顶部
        if (section) {
            const headerH = document.querySelector<HTMLElement>('.header')?.offsetHeight || 0;
            requestAnimationFrame(() => {
                lenis.scrollTo(section.getBoundingClientRect().top + window.scrollY - headerH);
            });
        }
    };

    let expanded = false;
    toggle.addEventListener('click', () => {
        expanded = !expanded;
        expanded ? expand() : collapse();
    });
})();
